var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-empty"},[_c('img',{attrs:{"src":require("../assets/images/waiting.png"),"width":"200pt","alt":""}}),_c('div',{staticClass:"text-gray1",domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }